import { UNITS, FUEL_TYPE, INSIGHTS_USAGE_COLORS, SLICK_ITEMS_TO_SHOW, USAGE_TYPE } from '../constants/common';
import { Configuration } from '../configs/Configuration';
import { bidgelyStorage } from './storageHelper';
import cssVars from 'css-vars-ponyfill';
import { cloneDeep } from 'lodash';

export const displayCost = (options) => {
    let displayCost = options.cost;
    if(options.round) {
        displayCost = Math.round(displayCost);
    }

    displayCost = formatNumber(displayCost);

    if(options.showCurrency) {
          displayCost = UNITS.$ + displayCost;
    }
    return displayCost;
}

export const displayUsage = (options) => {
    let displayUsage = options.usage;
    if(options.round) {
      displayUsage = Math.round(displayUsage);
    }

    displayUsage = formatNumber(displayUsage);
    if(options.showUsageUnit) {
        displayUsage += ' ' + getFuelUnit(options.fuelType);
    } else {
      displayUsage += ' ' + "W";
    }
    return displayUsage;
}

export const displayPercentage = (options) => {
  if(options.round){
    return Math.round(options.percentageVal) + '%';
  }
  return options.percentageVal + '%';
}

export const formatNumber = (number) => {
  number = number.toString();
  // replace decimal point character with ,/. as per the locale config
  return number.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

export const getUserLocale = (configData) => {
  let defaultLocale = configData.default_locale;
  let langToLocale = configData.language_to_locale ? JSON.parse(configData.language_to_locale) : {};

  let locale = defaultLocale.toLowerCase();
  let browserLocales = navigator.languages;
  if(browserLocales){
    for(let i = 0; i < browserLocales.length; i++){
      let isLocale = browserLocales[i].indexOf("-") != -1;
      //Check if it is a locale and a supported one, else check if it is a language and a supported one
      if(isLocale && isSupportedLocale(formatLocale(browserLocales[i]), configData)){
        locale = browserLocales[i].toLowerCase();
        break;
      } else if(!isLocale && isSupportedLanguage(browserLocales[i], configData)){
        locale = langToLocale[browserLocales[i]].toLowerCase();
        break;
      }
    }
  }
  return locale;
};

export const getBECompatibleLocale = (configData) => {
  let locale = getUserLocale(configData);
  return formatLocale(locale);
};

export const isSupportedLocale = (locale, configData) => {
  let supportedLocales = configData.supported_locale ? JSON.parse(configData.supported_locale) : [];
  supportedLocales.map((supportedLocale,index)=>{
    supportedLocales[index] = formatLocale(supportedLocale);
  })
  return supportedLocales && supportedLocales.indexOf(locale) != -1;
}

export const isSupportedLanguage = (lang, configData) => {
  let supportedLanguages = configData.supported_languages ? JSON.parse(configData.supported_languages) : [];
  return supportedLanguages && supportedLanguages.indexOf(lang) != -1;
}

export const formatLocale = (locale) => {
  let localPart = locale && locale.split("-");
  let lang = localPart && localPart.shift();
  let country = localPart && localPart.join("_").toUpperCase();
  return lang + "_" + country;
}
// This will parse response in key value value
export const parseResponse = responseData => {
    let parsedResponse = {};
    for (let i = 0; i < responseData.length; i++) {
      var config = responseData[i];
      parsedResponse[config.key] = config.val;
    }
    return parsedResponse;
};

export const replaceTokensInStrings = (originalStr, tokenMappingArray) => {
  if (originalStr && tokenMappingArray && tokenMappingArray.length) {
    for (let i = 0; i < tokenMappingArray.length; i++) {
      originalStr = originalStr.replace(new RegExp(tokenMappingArray[i].key, "g"), tokenMappingArray[i].value);
    }
  }
  return originalStr;
}

export const prepareColorsData = (colorsData) => {
  let colorsToCssVar = {};
  const DEFAULT_PALETTE = "default_palette_ui";
  if (colorsData[DEFAULT_PALETTE]) {
    for (const color in colorsData[DEFAULT_PALETTE]) {
      if (colorsData[DEFAULT_PALETTE].hasOwnProperty(color)) {
        colorsToCssVar["--" + color] = hexToRgb(colorsData[DEFAULT_PALETTE][color]);
      }
    }
  }
  // @TODO: handle page/module/page label color replacement
  return colorsToCssVar;
}

export const replaceColorsInCss = (colorsToReplace) => {
  cssVars({
    variables: colorsToReplace
  });
  Configuration.setColors(colorsToReplace);
}

export const getFuelUnit = (fuelType) => {
  return fuelType === FUEL_TYPE.GAS ? UNITS.CCF : UNITS.kWh;
}

export const setPageTitle = (titleKey, translations, configs) => {
  if(configs["DASHBOARD.UPDATE_PAGE_TITLE"] === "true"){
    document.title  = translations["UTILITY_NAME"] + " - " + translations[titleKey]
  }
}

export const getBECompatibleFuelType = (fuelType) => {
  return fuelType.toUpperCase();
}

export const  toTitleCase = (str) => {
  return str.replace(
      /\w\S*/g,
      function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
  );
}

export const hexToRgb = (hex) => {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return `${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)}`;
};

export const cloneObject = (obj) => {
  return cloneDeep(obj);
};

export const isCobrowsingMode = () => {
  return bidgelyStorage.getItem('isCobrowsing');
};

export const getApplianceColor = (applianceId) => {
  let colorData = Configuration.getColors().colors;
  return `rgb(${colorData[INSIGHTS_USAGE_COLORS[applianceId]]})`;
};

export const postMessageToIframe = (message) => {
  window.parent.postMessage(JSON.stringify(message), "*");
}
export const notifyHeightChange = (widgetId, height) => {
  postMessageToIframe({height: height, id: widgetId || ''});
}

export const getCurrentSlickRange = (current) => {
  if(window.innerWidth >= 800){
    return current+1 + '-' + (current+3);
  } else if(window.innerWidth < 800 && window.innerWidth > 550) {
    return current+1 + '-' + (current+2)
  } else {
    return current +1;
  }
}

export const getToggleUnit = (toggle, config) => {
  switch (toggle) {
    case USAGE_TYPE.COST : {
      return config.currency_unit
    }
    case USAGE_TYPE.USAGE : {
      return getFuelUnit(config.fuelType.toLowerCase())
    }
    case USAGE_TYPE.PERCENTAGE : {
      return '%';
    }
  }
}

export const isEmptyObject = (obj) => {
  for(var key in obj) {
    if(obj.hasOwnProperty(key))
      return false;
  }
  return true;
}
